const newpath = document.createElementNS('http://www.w3.org/2000/svg', 'path');

export const getLength = (d: string) => {
    newpath.setAttribute('d', d);
    const length = newpath.getTotalLength();
    const total = Math.round(length);
    return total;
};
